export enum MembershipRole {
	Owner = 0,
	Administrator,
	Manager,
	Member,
}

export const getMembershipRole = (role: MembershipRole) => {
	switch (role) {
		case MembershipRole.Owner:
			return { name: "Owner", class: "warning" };
		case MembershipRole.Administrator:
			return { name: "Administrator", class: "success" };
		case MembershipRole.Manager:
			return { name: "Manager", class: "info" };
		case MembershipRole.Member:
			return { name: "Member", class: "primary" };
		default:
			return { name: "Unknown Role", class: "danger" };
	}
};

export const organizationRoleDescriptions: Record<MembershipRole, string> = {
	[MembershipRole.Owner]: "Full access, plus billing/subscription management.",
	[MembershipRole.Administrator]: "Full access to manage and create productions, add other managers & administrators.",
	[MembershipRole.Manager]: "Management access to all production schedules, communications, people & resources.",
	[MembershipRole.Member]: "Not available for organizations.",
};

export const productionRoleDescriptions: Record<MembershipRole, string> = {
	[MembershipRole.Owner]: "Not available for productions.",
	[MembershipRole.Administrator]: "Full access to manage production and add other managers and administrators.",
	[MembershipRole.Manager]: "Can fully manage production schedule, communications, people & resources.",
	[MembershipRole.Member]: "View-only access to schedule, communications, and other production-related information.",
};
